import { Flex, Steps, Text } from "@/atoms"
import { DescriptiveSelect } from "@/molecules/DescriptiveSelect"

import styles from "./ConnectMethodSteps.module.scss"

import type { ConnectMethodStepsProps } from "./ConnectMethodSteps.types"

const STEP_STATUS = "process" as const

export function ConnectMethodSteps<T extends string>({
  selectTitle,
  value,
  options,
  onChange,
  actionTitle,
  action,
  helper
}: ConnectMethodStepsProps<T>) {
  return (
    <Steps
      size="small"
      theme="dark"
      className={styles.steps}
      orientation="vertical"
      items={[
        {
          title: selectTitle,
          content: (
            <DescriptiveSelect<T>
              value={value}
              onChange={onChange}
              values={options}
              className={styles.environmentSelect}
              classNames={{ popup: { root: styles.environmentSelectPopup } }}
              descriptionClassName={styles.optionDescription}
              popupMatchSelectWidth={false}
            />
          ),
          status: STEP_STATUS
        },
        {
          title: actionTitle,
          content: (
            <Flex vertical align="flex-start" gap={8}>
              {action}
              <Text type="secondary" className={styles.installHelper}>
                {helper}
              </Text>
            </Flex>
          ),
          status: STEP_STATUS
        }
      ]}
    />
  )
}
